module.exports = __webpack_public_path__ + "static/img/refrigerated-count.d9f274c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/track/1/refrigerated-count.png
// module id = dVG3
// module chunks = 1